module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_pingfen.88887.png";